import React from "react";
import { Grid, Typography } from "@mui/material";

export default function WidgetListHeader() {
  return (
    <Grid
      container
      sx={{
        backgroundColor: "#F5F6F8",
        borderRadius: "16px",
        padding: "16px",
        marginBottom: "8px",
      }}
    >
      <Grid item xs={1}>
        <Typography variant="body2" fontWeight={500} color="text.secondary">
          Order
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" fontWeight={500} color="text.secondary">
          Widget Name
        </Typography>
      </Grid>
      <Grid item xs={8} sx={{ paddingLeft: "70px" }}>
        <Typography variant="body2" fontWeight={500} color="text.secondary">
          Options
        </Typography>
      </Grid>
      <Grid item xs={1} textAlign="left">
        <Typography variant="body2" fontWeight={500} color="text.secondary">
          Remove
        </Typography>
      </Grid>
    </Grid>
  );
}
